<template>
	<main>
		<div class="picker">
			<section class="group" v-for="group in groups" :key="group">

				<div class="group-name">
					<h2 class="font-serif">{{ group }}</h2>
				</div>

				<div class="weapons">
					<section class="weapon"
						v-for="(weapon, weaponKey) in getWeaponObjectsByGroup( group )" :key="weaponKey"
						@click.left="setPrimaryWeapon( weapon.index )"
						@click.right.prevent="setSecondaryWeapon( weapon.index )"
						:class="[ { 'current current-primary' : weapon.index === currentPrimaryIndex }, { 'current current-secondary' : weapon.index === currentSecondaryIndex } ]">

						<div class="img-container" :class="[ { 'noimg' : !weapon.pickup_str }, { 'noimg-custom' : weapon.id === 'PChoice' } ]">
							<div v-if="weapon.pickup_str" class="img-bg" :style="{ backgroundImage : `url(${getWeaponImageUrl( weapon.pickup_str )})` }"></div>
							<div v-else class="img-bg"></div>
						</div>

						<div class="details">
							<h3 class="name font-sans">{{ weapon.name }}</h3>
							<div v-if="showExtraData && (weapon.index !== 4 && weapon.index !== -1)" class="specs font-sans">
								<div class="spec-row" v-for="([objKey, objVal]) in Object.entries( weapon )" :key="objKey">
									<div v-if="objVal !== -1" class="spec-key">{{ objKey }}:</div>
									<div v-if="objVal !== -1" class="spec-value">{{ objVal }}</div>
								</div>
							</div>
						</div>
					</section>
				</div>

			</section>
		</div>

		<CurrentWeaponsRack :primaryWpn="getWeaponObjectByIndex( currentPrimaryIndex )" :secondaryWpn="getWeaponObjectByIndex( currentSecondaryIndex )"/>

	</main>
</template>

<script>
	import weapons from '@/modules/data/weapons';
	import CurrentWeaponsRack from '@/components/CurrentWeaponsRack';

	export default {
		name: 'Weapons',
		components: {
			CurrentWeaponsRack
		},
		data() {
			return {
				weapons,
				groups: [
					'None',
					'Revolver',
					'Pistol',
					'SMG',
					'Shotgun',
					'Rifle',
					'Grenade Launcher',
					'Special',
					'Melee',
					'Melee + Thrown',
					'Thrown',
					'Consumable',
				],
			}
		},
		computed: {
			showExtraData()
			{
				return this.$store.getters.getShowExtraData;
			},
			currentPrimaryIndex()
			{
				return this.$store.getters.getPrimaryWeapon;
			},
			currentSecondaryIndex()
			{
				return this.$store.getters.getSecondaryWeapon;
			}
		},
		//@TODO: Tidy this up
		methods: {
			filterAvailableWeapons( weaponSet )
			{
				// Filter out templates/broken/unfinished
				return weaponSet.filter( w => !w.is_console && w.is_working && w.type !== 'bullet' );
			},
			getWeaponObjectsByGroup( group )
			{
				return this.filterAvailableWeapons( weapons.filter( w => w.group === group ) );
			},
			getWeaponObjectByIndex( wpnIndex )
			{
				return this.filterAvailableWeapons( weapons.filter( w => w.index === wpnIndex ) )[0];
			},
			getWeaponImageUrl( pickup_str )
			{
				return ( pickup_str && pickup_str !== -1 ) ? require( `@/assets/sprites/weapon/${pickup_str}.png` ) : '';
			},
			setPrimaryWeapon( weaponIndex )
			{
				const newWeaponIndex = ( this.currentPrimaryIndex === weaponIndex ) ? -1 : weaponIndex;

				this.$store.commit( 'setPrimaryWeapon', newWeaponIndex );
			},
			setSecondaryWeapon( weaponIndex )
			{
				const newWeaponIndex = ( this.currentSecondaryIndex === weaponIndex ) ? -1 : weaponIndex;

				this.$store.commit( 'setSecondaryWeapon', newWeaponIndex );
			},
		},
	}
</script>


<style lang="scss" scoped>
	@import '@/assets/scss/_variables.scss';

	$img-container-height: 70px;

	main {
		display: grid;
		grid-template-columns: 60% auto;
	}

	.group {
		display: grid;
		grid-template-columns: 120px auto;
		margin-bottom: 20px;
	}

	.group-name {
		align-items: center;
		display: flex;
		height: $img-container-height;

		// h2 {}
	}

	// Grid
	// ====================================

	.weapons {
		display: flex;
		flex-wrap: wrap;

		.weapon {
			flex: 0 0 calc(20% - 20px);
			margin-right: 20px;
		}
	}

	.firemode {
		margin-bottom: 10px;
	}


	// Single
	// ====================================

	.name {
		font-size: 1.2rem;
	}

	.details {
		padding: 10px;
		// text-align: center;
	}

	// Image
	// ====================================

	.img-container {
		background-color: #383D3F;
		image-rendering: pixelated;
		padding: 20px;
		height: $img-container-height;
	}

	.img-bg {
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		filter: drop-shadow(2px 4px 0px rgba(0, 0, 0, 0.2));
		height: 30px;
		margin: 0 auto;
		// width: 100px;
		width: 100%;
		transition: 0.3s;
	}


	// Hover + Active
	// ====================================

	.weapon {
		position: relative;
		cursor: pointer;
		background-color: #222222;
		margin-bottom: 10px;
		transition: 0.15s;

		&:hover {
			background-color: #2d2d2d;

			.img-container {
				background-color: #383D3F;
			}

			.img-bg {
				filter: drop-shadow(2px 4px 2px rgba(0, 0, 0, 0.5));
				transform: translate(-2px, -2px);
			}
		}

		&.current {
			.details {
				// color: #000;
			}
		}

		&.current-primary {
			background-color: $color-g;

			.weaponborder-left {
				display: block;
			}
			// .details {}
		}

		&.current-secondary {
			background-color: $color-b;

			.weaponborder-right {
				display: block;
			}
			// .details {}
		}

		&.current-primary.current-secondary {
			background-color: $color-or;
		}
	}

	// Extras
	// ============================

	.specs {
		font-family: $font-sans;
		font-size: .9rem;
		line-height: 1.1;
		margin-top: 5px;
		width: 100%;
	}

	.spec-row {
		display: flex;

		&:nth-of-type(odd) {
			background-color: rgba(255, 255, 255, .1);
		}
	}

	.spec-key {
		flex: 0 0 80px;
	}

	.spec-value {
		text-align: right;
		flex: 1 1 auto;
	}
</style>
